module.exports = __webpack_public_path__ + "img/step-3-alt.745139fa.svg";